"use strict";

var _defineProperty = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/defineProperty.js");

var _taggedTemplateLiteral = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var object_hash_1 = __importDefault(require("object-hash"));

var react_1 = __importStar(require("react"));

var redux_form_1 = require("redux-form");

var FormidableContext_1 = __importDefault(require("../../../FormidableContext"));

var initializeValues_1 = __importDefault(require("../../../utils/initializeValues"));

var Group_1 = __importDefault(require("../../Group"));

var Field_1 = __importDefault(require("../Field"));

var index_1 = __importDefault(require("../index"));

var ButtonSC = styled_1.default.button(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

var DataArrayRender = function DataArrayRender(_ref) {
  var addButtonProps = _ref.addButtonProps,
      bodyProps = _ref.bodyProps,
      className = _ref.className,
      customInfos = _ref.customInfos,
      customInfosProps = _ref.customInfosProps,
      datas = _ref.datas,
      fields = _ref.fields,
      formName = _ref.formName,
      formValues = _ref.formValues,
      groupProps = _ref.groupProps,
      params = _ref.params,
      removeButtonProps = _ref.removeButtonProps;

  var _ref2 = (0, react_1.useContext)(FormidableContext_1.default),
      sc = _ref2.sc,
      t = _ref2.t;

  var newDatas = datas && !Array.isArray(datas) ? [datas] : datas;

  var handleAddButtonOnClick = function handleAddButtonOnClick(event) {
    event.preventDefault();
    fields.push(newDatas ? (0, initializeValues_1.default)(newDatas) : '');
  };

  var handleRemoveButtonOnClick = function handleRemoveButtonOnClick(event) {
    var index = event.currentTarget.getAttribute('data-index');

    if (index) {
      fields.remove(parseInt(index, 10));
    }
  };

  var addButtonPosition = 'top';
  var addButtonLabel;

  if (addButtonProps) {
    if (addButtonProps.position) {
      addButtonPosition = addButtonProps.position;
    }

    addButtonLabel = addButtonProps.label;
  }

  var WrapperGroup = groupProps ? Group_1.default : react_1.default.Fragment;
  var wrapperProps = groupProps ? _objectSpread(_objectSpread({}, groupProps), {}, {
    className: className,
    customInfos: 'top' === addButtonPosition && addButtonProps && react_1.default.createElement(ButtonSC, _objectSpread({
      as: sc && sc.button,
      onClick: handleAddButtonOnClick
    }, addButtonProps), t && addButtonLabel ? t(addButtonLabel) : addButtonLabel)
  }) : undefined;
  return react_1.default.createElement(WrapperGroup, _objectSpread({}, wrapperProps), !groupProps && 'top' === addButtonPosition && Boolean(addButtonProps) && react_1.default.createElement(ButtonSC, _objectSpread({
    as: sc && sc.button,
    onClick: handleAddButtonOnClick
  }, addButtonProps), t && addButtonLabel ? t(addButtonLabel) : addButtonLabel), fields && fields.map(function (field, index) {
    var removeCmp = removeButtonProps && react_1.default.createElement(ButtonSC, _objectSpread({
      as: sc && sc.button,
      "data-index": index,
      onClick: handleRemoveButtonOnClick
    }, removeButtonProps), t && removeButtonProps.label ? t(removeButtonProps.label) : removeButtonProps.label);

    if (newDatas && newDatas.length > 0) {
      if (newDatas.length > 1 || newDatas[0].datas || newDatas[0].name) {
        return react_1.default.createElement(redux_form_1.FormSection, _objectSpread({
          key: "".concat(field, "_").concat((0, object_hash_1.default)(_objectSpread(_objectSpread({}, newDatas), {}, {
            datas: null,
            params: null
          }))),
          "data-index": index,
          name: field
        }, bodyProps), newDatas.map(function (value) {
          return react_1.default.createElement(index_1.default, _objectSpread(_objectSpread({
            key: "".concat(field, "_").concat((0, object_hash_1.default)(value))
          }, value), {}, {
            customInfosProps: customInfosProps,
            formName: formName,
            formValues: formValues,
            params: _objectSpread(_objectSpread({}, params), {}, {
              index: index,
              count: index + 1,
              name: field
            })
          }));
        }), customInfos, removeCmp);
      }

      return react_1.default.createElement("div", _objectSpread({
        key: field,
        "data-index": index
      }, bodyProps), react_1.default.createElement(index_1.default, _objectSpread(_objectSpread({}, newDatas[0]), {}, {
        formName: formName,
        formValues: formValues,
        name: field,
        params: _objectSpread(_objectSpread({}, params), {}, {
          name: field
        })
      })), customInfos, removeCmp);
    }

    return react_1.default.createElement("div", _objectSpread({
      key: field,
      "data-index": index
    }, bodyProps), react_1.default.createElement(Field_1.default, {
      componentType: "input",
      formName: formName,
      formValues: formValues,
      labelShow: false,
      name: field,
      params: _objectSpread(_objectSpread({}, params), {}, {
        name: field
      })
    }), customInfos, removeCmp);
  }), 'bottom' === addButtonPosition && react_1.default.createElement(ButtonSC, _objectSpread({
    as: sc && sc.button,
    onClick: handleAddButtonOnClick
  }, addButtonProps), t && addButtonLabel ? t(addButtonLabel) : addButtonLabel));
};

exports.default = DataArrayRender;